<template>
  <div class="body-inner">
    <div class="modal-dim on" :class="{ 'logout-confirm': variant === 'logout' }">
      <!--'on 추가'-->
      <div class="modal-wrap">
        <div class="modal-inner center">
          <div class="modal">
            <div class="modal-con">
              <div class="modal-txt">
                <div class="txt-ttl">{{ layout.title }}</div>
                <div class="txt-con">
                  <p v-html="layout.contents"></p>
                </div>
              </div>
            </div>
            <div class="modal-btn">
              <div class="btn-wrap">
                <button class="btn bo yd-cta yd-cta--secondary" v-on:click="fnCallBackCancel">
                  {{ locale === 'ko' ? '취소' : cancelText }}
                </button>
                <button class="btn yd-cta yd-cta--primary" v-on:click="fnCallBackDone">
                  {{ locale === 'ko' ? '확인' : doneText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'modal-alert-confirm',
  props: {
    layout: {
      type: [Object],
      default: () => {}
    },
    data: {
      type: [Object],
      default: () => {}
    },
    doneText: {
      type: [String],
      default: 'OK'
    },
    cancelText: {
      type: [String],
      default: 'CANCEL'
    },
    variant: {
      type: String,
      default: ''
    },
    callBackDone: {
      type: [Function],
      default: () => {}
    },
    callBackCancel: {
      type: [Function],
      default: () => {}
    }
  },
  emits: ['close'],
  setup(props) {
    const { getters, dispatch } = useStore();
    const { proxy } = getCurrentInstance();
    const fnCallBackCancel = (event) => {
      props.callBackCancel(proxy, event);
    };
    const fnCallBackDone = (event) => {
      props.callBackDone(proxy, event);
    };
    const locale = computed(() => getters['locale/getLocale']);

    return { fnCallBackCancel, fnCallBackDone, locale };
  }
};
</script>

<style scoped>
.logout-confirm::before {
  background-color: rgba(15, 23, 42, 0.42);
}

.logout-confirm .modal-wrap {
  padding: 1.6rem;
}

.logout-confirm .modal-inner.center .modal {
  width: min(100%, 34rem);
  min-width: 0;
  overflow: hidden;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.18);
}

.logout-confirm .modal-con {
  min-height: 0;
  padding: 2.4rem 2rem 2rem;
}

.logout-confirm .modal-txt,
.logout-confirm .txt-con,
.logout-confirm .txt-con p {
  width: 100%;
  margin: 0;
  color: #26313b;
  font-size: 1.4rem;
  line-height: 1.55;
  text-align: center;
  overflow-wrap: anywhere;
}

.logout-confirm .txt-ttl:empty {
  display: none;
}

.logout-confirm .modal-btn .btn-wrap {
  display: flex;
  width: 100%;
  padding: 0 1.6rem 1.6rem;
  gap: 1rem;
}

.logout-confirm .modal-btn .btn-wrap .btn,
.logout-confirm .modal-btn .btn-wrap .btn.bo {
  width: 100%;
  height: 44px;
  margin: 0;
  padding: 0 1.2rem;
  border-radius: 9px;
  font-size: 1.4rem;
  font-weight: 600;
}

.logout-confirm .modal-btn .btn-wrap .btn.bo {
  color: #4f5b66;
  background: #f4f6f7;
  border: 1px solid #dfe4e7;
}

.logout-confirm .modal-btn .btn-wrap .btn:not(.bo) {
  color: #ffffff;
  background: #36cad9;
  border: 1px solid #36cad9;
}
</style>
